import GmailDataExtractionService from './gmailDataExtractionService';
import GoogleSheetsDataExtractionService from './googleSheetsDataExtractionService';
import HubspotDataExtractionService from './hubspotDataExtractionService';
import LinkedinDataExtractionService from './linkedinDataExtractionService';
import MeetingDataExtractionService from './meetingDataExtractionService';
import MicrosoftDynamicsDataExtractionService from './microsoftDynamicsDataExtractionService';
import SalesforceDataExtractionService from './salesforceDataExtractionService';
import SalesforceLightningDataExtractionService from './salesforceLightningDataExtractionService';
import SalesloftDataExtractionService from './salesloftDataExtractionService';
import SalesNavDataExtractionService from './salesNavDataExtractionService';

const createDataExtractionService = () => ({
  linkedin: LinkedinDataExtractionService,
  salesNav: SalesNavDataExtractionService,
  meeting: MeetingDataExtractionService,
  salesloft: SalesloftDataExtractionService,
  hubspot: HubspotDataExtractionService,
  microsoftDynamics: MicrosoftDynamicsDataExtractionService,
  salesforce: SalesforceDataExtractionService,
  salesforceLightning: SalesforceLightningDataExtractionService,
  gmail: GmailDataExtractionService,
  googleSheets: GoogleSheetsDataExtractionService,
});

const DataExtractionService = createDataExtractionService();

export default DataExtractionService;
